import React, { Component } from 'react';
import YouTube from 'react-youtube';

class Modal extends Component {

    constructor(props) {

        super(props)

        this.state = {
            showModal: false,
            video: null,
            photo: null
        }

        this.handleClose = this.handleClose.bind(this)

    }

    handleClose() {
        this.setState({
            'showModal': false,
            'video': null,
            'photo': null
        })
    }

    componentDidMount() {

        //Listeners

        document.addEventListener('video:open', (response) => {
            this.setState({
                'showModal': true,
                'video': response.detail
            })
        })

        document.addEventListener('photo:open', (response) => {
            this.setState({
                'showModal': true,
                'photo': response.detail
            })
        })

    }

    render() {

        const { showModal, video, photo } = this.state

        let ModalContent = null

        if (video) {
            ModalContent = (
                <YouTube {...video} onEnd={this.handleClose} />
            )
        } else if (photo) {
            ModalContent = (
                <div className="gallery__item-popup">
                    <div className="gallery__item-image" style={{ backgroundImage: `url("${encodeURI(photo.image)}")` }}></div>
                    <div className="gallery__item-content">
                        <div className="gallery__item-entry">
                            <h2 dangerouslySetInnerHTML={{ __html: photo.title }}></h2>
                            <p dangerouslySetInnerHTML={{ __html: photo.description }}></p>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className={'modal-wrapper' + (showModal ? ' visible' : '')}>
                <div className="modal-wrapper__content">{ModalContent}</div>
                <a href="javascript:void(0)" className="btn-close" title="Fechar" onClick={this.handleClose}>Fechar</a>
            </div>
        )

    }

}

export default Modal